module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Denna post finns tyvärr inte":"Sorry, this post does not exist"},"sv":{"Denna post finns tyvärr inte":"Denna post finns tyvärr inte"}}')
  delete Component.options._Ctor
}
